export const MAKE_REQUEST = "MAKE_REQUEST";
export const FAIL_REQUEST = "FAIL_REQUEST";
export const POST_SUCCESS = "POST_SUCCESS";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";

export const GET_DISCUSSION = "GET_DISCUSSION";
